'use client';

import { FileQuestion } from 'lucide-react';

interface TweetNotFoundProperties {
  message?: string | undefined;
  tweetId?: string | undefined;
}

export function TweetNotFound({ message, tweetId }: TweetNotFoundProperties) {
  return (
    <div className="my-3 rounded-xl border border-border/60 bg-muted/25 p-6">
      <div className="flex flex-col items-center text-center">
        <FileQuestion className="h-10 w-10 text-muted-foreground mb-3" />
        <h3 className="font-semibold text-foreground mb-1">Tweet not found</h3>
        <p className="text-sm text-muted-foreground max-w-sm">
          {message || 'This tweet may have been deleted or is from a private account.'}
        </p>
        {tweetId && (
          <a
            href={`https://twitter.com/i/status/${tweetId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-primary hover:text-primary/80 hover:underline mt-3"
          >
            View on Twitter →
          </a>
        )}
      </div>
    </div>
  );
}
